<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$consts.allianceName()]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$consts.allianceName()]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <ValidationObserver ref="observer">
          <v-form>
            <v-card-text>
              <v-container>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.alliance_business_code", [
                        $consts.allianceName(),
                      ]) + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="
                        $t('Alliances.Fields.alliance_business_code', [
                          $consts.allianceName(),
                        ])
                      "
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="alliance.alliance_business_code"
                        :hint="
                          isNew
                            ? ''
                            : $t('Alliances.codeHint', [$consts.allianceName()])
                        "
                        :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'alliance_business_code'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ alliance.alliance_business_code }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.alliance_business_name", [
                        $consts.allianceName(),
                      ]) + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="
                        $t('Alliances.Fields.alliance_business_name', [
                          $consts.allianceName(),
                        ])
                      "
                      rules="required"
                    >
                      <v-text-field
                        single-line
                        v-model="alliance.alliance_business_name"
                        :hint="
                          isNew
                            ? ''
                            : $t('Alliances.nameHint', [$consts.allianceName()])
                        "
                        :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'alliance_business_name'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ alliance.alliance_business_name }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.alliance_district", [
                        $consts.allianceName(),
                      ]) + $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="
                        $t('Alliances.Fields.alliance_district', [
                          $consts.allianceName(),
                        ])
                      "
                      rules="required"
                    >
                      <SearcherDistrict
                        v-model="alliance.district"
                        no-label
                        unclearable
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'city_1')
                            .concat(errors)
                        "
                      />
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      alliance && alliance.district
                        ? alliance.district.name
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="3"
                    :class="
                      savable
                        ? 'font-weight-bold text-right mt-8'
                        : 'font-weight-bold text-right'
                    "
                  >
                    {{
                      $t("Alliances.Fields.alliance_address", [
                        $consts.allianceName(),
                      ]) + $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <!-- 三级地址 -->
                    <CitiesSelectGroup
                      :masterItem="alliance"
                      @provinceSelected="alliance.province_id = $event.id"
                      @citySelected="alliance.city_id = $event.id"
                      @districtSelected="alliance.area_id = $event.id"
                    />
                    <v-text-field single-line v-model="alliance.address" />
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <!-- {{ alliance.address }} -->
                    <!-- 三级地址 -->
                    <AddressText
                      :masterItem="alliance"
                      :detailAddress="alliance.address"
                    />
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.alliance_seller_price") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="alliance.seller_price">
                      <v-radio
                        v-for="price in sellerPrice"
                        :key="price.value"
                        :label="`${price.text}`"
                        :value="price.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ alliance.seller_price | allianceSellerPriceStatusText }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Alliances.Fields.status") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-radio-group row v-model="alliance.status">
                      <v-radio
                        v-for="stat in status"
                        :key="stat.value"
                        :label="`${stat.text}`"
                        :value="stat.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    <v-chip color="primary" small label>
                      {{ alliance.status | alliancesStatusText }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Alliances.Fields.memo") + $t("Global.colon") }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-textarea
                      outlined
                      v-model="alliance.comment"
                    ></v-textarea>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ alliance.comment }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.alliance_user_name") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Alliances.Fields.alliance_user_name')"
                      rules="required"
                    >
                      <v-text-field
                        v-if="alliance && alliance.account_user"
                        single-line
                        v-model="alliance.account_user.name"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'account_user.name')
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      alliance && alliance.account_user
                        ? alliance.account_user.name
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.identification_num") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <v-text-field
                      v-if="alliance && alliance.account_user"
                      v-model="alliance.account_user.identification_num"
                      single-line
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      alliance && alliance.account_user
                        ? alliance.account_user.identification_num
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Alliances.Fields.tel") + $t("Global.colon") }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Alliances.Fields.tel')"
                      rules="required|mobile"
                    >
                      <v-text-field
                        v-model="alliance.account_user.mobile"
                        single-line
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'account_user.mobile')
                            .concat(errors)
                        "
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{ alliance.account_user.mobile }}
                  </v-col>
                </v-row>
                <v-row align="center">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.account_user_id") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7" v-if="savable">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Alliances.Fields.account_user_id')"
                      rules="required|min:6"
                    >
                      <v-text-field
                        single-line
                        v-if="alliance && alliance.account_user"
                        v-model="alliance.account_user.account_user_id"
                        :hint="
                          isNew
                            ? ''
                            : $t('Alliances.loginUserNameHint', [
                                $consts.allianceName(),
                              ])
                        "
                        :error-messages="
                          $resparse
                            .getErrorMsgs(
                              serverErrors,
                              'account_user.account_user_id'
                            )
                            .concat(errors)
                        "
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="9" md="7" v-else>
                    {{
                      alliance && alliance.account_user
                        ? alliance.account_user.account_user_id
                        : ""
                    }}
                  </v-col>
                </v-row>
                <v-row align="center" v-if="savable && isNew">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.account_user_password") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" :mode="mode" />
                  </v-col>
                  <v-col cols="9" md="7">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Alliances.Fields.account_user_password')"
                      rules="required|min:6"
                    >
                      <v-text-field
                        v-if="alliance && alliance.account_user"
                        single-line
                        v-model="alliance.account_user.password"
                        :error-messages="
                          $resparse
                            .getErrorMsgs(serverErrors, 'account_user.password')
                            .concat(errors)
                        "
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row align="center" v-else-if="savable && !isNew">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{
                      $t("Alliances.Fields.account_user_password") +
                      $t("Global.colon")
                    }}
                    <Required :show="savable" />
                  </v-col>
                  <v-col cols="9" md="7">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('Alliances.Fields.account_user_password')"
                      rules="min:6"
                    >
                      <v-text-field
                        v-if="alliance && alliance.account_user"
                        single-line
                        v-model="alliance.account_user.password"
                        :hint="isNew ? '' : $t('Alliances.loginPasswordHint')"
                        :error-messages="errors"
                      >
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row align="center" v-if="isView">
                  <v-col cols="3" class="font-weight-bold text-right">
                    {{ $t("Alliances.Fields.weQr") + $t("Global.colon") }}
                  </v-col>
                  <v-col cols="9" md="7">
                    <v-img
                      max-width="140"
                      :src="alliance.weQrCode_url"
                      @click.stop="$showFullscreenImages([alliance.weQrCode_url])"
                    >
                    </v-img>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-form>
        </ValidationObserver>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $emit('input', null);
                    $emit('mode', null);
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{ $t("CRUD.backToList", [$consts.allianceName()]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&
                  $permission.permissionAllow('AllianceBusinesses', 'edit')
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !alliance.id"
                  @click="$emit('mode', 'edit')"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{ $t("CRUD.editInfo", [$consts.allianceName()]) }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow(
                    'AllianceBusinesses',
                    isNew ? 'add' : 'edit'
                  )
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !alliance.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{ $t("CRUD.saveInfo", [$consts.allianceName()]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4" v-if="isView">
          <v-card-title>
            <v-row dense>
              <v-col cols="12" v-if="isView && alliance.id">
                <v-btn
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !alliance.id"
                  :href="'/#/alliances/edit-shop/' + alliance.id"
                >
                  {{ $t("Alliances.actions.manage_shop", [$consts.shopName()]) }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Consts from "@/consts.js";
import Required from "@/components/plugins/Required";
import AllianceBusinesses from "@/api/alliance_businesses";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import CitiesSelectGroup from "@/components/plugins/CitiesSelects";
import AddressText from "@/components/plugins/AddressText";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "AllianceDetail",

  props: ["value", "mode"],

  components: {
    Required,
    SearcherDistrict,
    CitiesSelectGroup,
    AddressText,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.alliance.status;
    },
    sellerPrice() {
      return Consts.alliance.alliance_seller_price;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading"]),
  },

  data: () => ({
    alliance: {},
    serverErrors: [],
  }),

  methods: {
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.$refs.observer.validate().then(
        function (result) {
          if (result) {
            var alliance = JSON.parse(JSON.stringify(this.alliance));
            if (this.alliance.district && this.alliance.district.code) {
              alliance.city_1 = this.alliance.district.code;
            }
            delete alliance.district;
            AllianceBusinesses.save(alliance.id, alliance)
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.$emit("save", alliance);
                    this.$emit("mode", null);
                    this.$emit("input", null);
                    this.$refs.observer.reset();
                    this.$store.dispatch("fullscreenLoadingStop");
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.$store.dispatch("fullscreenLoadingStop");
                    this.serverErrors = response.data.error.data;
                  }
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          AllianceBusinesses.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.alliance = response.data.alliance_business;
                if (!this.alliance.weQrCode_url) {
                  AllianceBusinesses.getWxQrCode(this.alliance.id).then(
                    function (res) {
                      if (res.data.status.isOK()) {
                        this.alliance.weQrCode_url = res.data.data.img_url;
                      }
                    }.bind(this)
                  )
                }
              }
            }.bind(this)
          );
        } else {
          // 新建门店，初始化默认值
          this.alliance = {
            status: 1,
            seller_price: 1,
            account_user: {},
            province_id: 0,
            province_name: "",
            city_id: 0,
            city_name: "",
            area_id: 0,
            area_name: "",
          };
        }
        this.$scrollTop(); //返回顶部
      },
    },
  },
};
</script>